export const SELECTION_COLUMN_MAX_WIDTH = '68px'
export const ACTIONS_COLUMN_MAX_WIDTH = '141px'
